import React from 'react';
import { observer } from 'mobx-react';
import companySearchState from 'Stores/companySearch';
import { userDetail } from 'Stores/userDetail';
import CheckBox from 'Components/common/CheckBox';

const OptionsCompany = observer(props => {
  const { filterInPage = true } = props;
  let checkBoxFilters;
  if (filterInPage) checkBoxFilters = companySearchState.checkBoxFilters;

  const onCheckBoxClick = val => {
    if (filterInPage) {
      console.log('true');
      companySearchState.setCheckBoxFilters(val);
    }
  };

  return (
    <div className="input-section options-section check-box-wrap">
      <div
        className={`title-checkbox${
          checkBoxFilters.dontDisplayOwnedCompanies ? ' selected' : ''
        }`}
        onClick={() => onCheckBoxClick('dontDisplayOwnedCompanies')}
      >
        <div className="check-box">
          <CheckBox
            dymamicClass={
              checkBoxFilters.dontDisplayOwnedCompanies ? 'selected' : ''
            }
          />
        </div>
        <span className="check-box-label">Exclude companies I own</span>
      </div>
      <div
        className={`title-checkbox${
          checkBoxFilters.dontDisplayTeamCompanies ? ' selected' : ''
        }`}
        onClick={() => onCheckBoxClick('dontDisplayTeamCompanies')}
      >
        <div className="check-box">
          <CheckBox
            dymamicClass={
              checkBoxFilters.dontDisplayTeamCompanies ? 'selected' : ''
            }
          />
        </div>
        <span className="check-box-label">Exclude companies my team owns</span>
      </div>
    </div>
  );
});

export { OptionsCompany };
export default OptionsCompany;
